import { useState } from 'react'

import { TFunction } from 'i18next'
import { buttonText, errorT } from '../../../../../utils/ec-flow-texts'
import { NavigateFunction } from 'react-router-dom'
import i18n from '../../../../../../../client/src/i18n'
import {
  CampaignIncentive,
  EndUserCampaign,
  PartialEndUser,
} from '../../../../../lib/api/types'
import { endUserType } from '../../../../../utils/user-type'
import { Button } from '@alphabait/ui'
import Header from '../../../../header'
import IncentiveCard from '../components/IncentiveCard'

export default function ChooseIncentive({
  campaign,
  endUser,
  t,
  pathname,
  navigate,
  onSubmit,
  error,
  setError,
  chosenCodeHasExpired,
}: {
  campaign: EndUserCampaign
  endUser: PartialEndUser
  t: TFunction<'translation', undefined>
  pathname: string
  id?: string
  navigate: NavigateFunction
  onSubmit: (selectedIncentive?: string) => void
  error?: string
  setError: (error: string) => void
  chosenCodeHasExpired?: boolean
}) {
  const language = i18n.language
  const typeOfUser = endUserType(endUser.referral)
  const [selectedIncentive, setSelectedIncentive] = useState<
    string | undefined
  >()

  const translations =
    campaign?.ecFlowTexts?.ecFlowTexts?.[typeOfUser]?.['incentive']?.[language]

  const handleSelectIncentive = (id: string) => {
    setSelectedIncentive(id)
    setError('')
  }

  const isLottery = campaign.campaignCategory === 'lottery'

  const isReferral = !!endUser.referralOf


  const Incentives = () => {
    if (!campaign?.campaignIncentives) return null

    return campaign?.campaignIncentives?.map(
      (campaignIncentive: CampaignIncentive | null, index: number) => {
        return (
          <IncentiveCard
            key={`${campaignIncentive?.id}-${index}`}
            campaignIncentive={campaignIncentive}
            selected={selectedIncentive === campaignIncentive?.id}
            onSelect={handleSelectIncentive}
          />
        )
      },
    )
  }

  return (
    <div className="min-h-full flex flex-col bg-background">
      <Header
        title={translations?.header ?? t('ec.choose_incentive.sub_title')}
        subTitle={
          translations?.text == null
            ? (isLottery && !isReferral
              ? t('ec.choose_incentive.header_lottery')
              : t('ec.choose_incentive.header'))
            : translations.text || undefined
        }
        pathname={pathname}
      />

      {/* Main content */}
      <div className="grid flex-1 px-6 pb-4 bg-background max-w-md m-auto">
        {chosenCodeHasExpired && !selectedIncentive && (
          <p className="text-sm text-red-700 text-center">
            {errorT(campaign)('ec.choose_incentive.code_has_expired')}
          </p>
        )}
        <div
          className="gap-4 flex flex-col w-full max-w-sm mx-auto px-2"
          data-test-id="incentives"
        >
          <Incentives />
        </div>
        {error && (
          <div className="text-destructive text-sm w-full text-center">
            {errorT(campaign)(error)}
          </div>
        )}
      </div>

      {/* Buttons - fixed at bottom */}
      <div className="grid gap-4 py-4 mx-auto w-full bg-background max-w-sm px-6">
        <Button
          variant="next"
          size="lg"
          onClick={() => onSubmit(selectedIncentive)}
          data-testid="next-button"
        >
          {buttonText(campaign, 'next', t)}
        </Button>
        <Button
          variant="back"
          size="lg"
          onClick={() => navigate(-1)}
          data-testid="back-button"
        >
          {buttonText(campaign, 'back', t)}
        </Button>
      </div>
    </div>
  )
}
